// Client-side titleize for shop display names. Mirrors the server helper at
// src/backend/utils/shopName.js. Used to clean up legacy localStorage / API
// values that still hold a raw Shopify dev-store handle like
// "ecomoria-billing-dev2" instead of a real display name.

function looksLikeHandle(name) {
  if (!name || typeof name !== 'string') return false;
  const trimmed = name.trim();
  if (!trimmed) return false;
  if (/[A-Z]/.test(trimmed)) return false;
  if (/\s/.test(trimmed)) return false;
  return /^[a-z0-9]+(-[a-z0-9]+)+$/.test(trimmed);
}

function titleizeHandle(handle) {
  return handle
    .split('-')
    .filter(Boolean)
    .map(t => t.charAt(0).toUpperCase() + t.slice(1))
    .join(' ');
}

export function normalizeShopDisplayName(rawName) {
  if (!rawName) return '';
  if (looksLikeHandle(rawName)) return titleizeHandle(rawName);
  return rawName;
}
